import { Toaster } from "@blueprintjs/core";


const zrToaster = Toaster.create({
	className: "zr-toaster"
});

export default zrToaster;
